<template>
    <div class="navbar">
        <!--    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />-->
        <!--    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />-->
        <hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
        <breadcrumb id="breadcrumb-container" class="breadcrumb-container"/>

        <div class="right-menu">
            <exchange-rate-tool></exchange-rate-tool>
            <template v-if="device!=='mobile'">
                <!--        <search id="header-search" class="right-menu-item" />-->
                <!--        <error-log class="errLog-container right-menu-item hover-effect" />-->

                <!--        <el-tooltip :content="$t('navbar.size')" effect="dark" placement="bottom">-->
                <!--          <size-select id="size-select" class="right-menu-item hover-effect" />-->
                <!--        </el-tooltip>-->
                <screenfull id="screenfull" class="right-menu-item hover-effect"/>
                <lang-select class="right-menu-item hover-effect"/>
            </template>

            <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
                <div class="avatar-wrapper">
<!--                    <img :src="avatar+'?imageView2/1/w/80/h/80'" class="user-avatar">-->
                    <img :src="icon" class="user-avatar">
                    <i class="el-icon-caret-bottom"/>
                </div>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item >
                        已登录 <span style="color: #409EFF;font-weight: bold;">{{this.$store.state.user.name}}</span>
                    </el-dropdown-item>
                    <router-link to="/">
                        <el-dropdown-item divided>
                            {{ $tc('navbar.dashboard') }}
                        </el-dropdown-item>
                    </router-link>
                    <span @click="goChangePw">
                        <el-dropdown-item>{{ $tc('navbar.changePassword') }}</el-dropdown-item>
                    </span>
                    <!--<a target="_blank" href="#">
                      <el-dropdown-item>Docs</el-dropdown-item>
                    </a>-->
                    <el-dropdown-item divided>
                        <span style="display:block;" @click="logout">{{ $tc('navbar.logOut') }}</span>
                    </el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Breadcrumb from '@/components/Breadcrumb'
    import Hamburger from '@/components/Hamburger'
    import Screenfull from '@/components/Screenfull'
    import LangSelect from '@/components/LangSelect'
    import exchangeRateTool from '@/components/exchangeRateTool'

    import admin_icon from '@/assets/images/admin.jpg'
    // import ErrorLog from '@/components/ErrorLog'
    // import SizeSelect from '@/components/SizeSelect'
    // import Search from '@/components/HeaderSearch'
    export default {
        components: {
            LangSelect,
            Breadcrumb,
            Hamburger,
            Screenfull,
            exchangeRateTool,
            // ErrorLog,
            // SizeSelect,
            // Search
        },
        computed: {
            ...mapGetters([
                'sidebar',
                'avatar',
                'device'
            ])
        },
        methods: {
            toggleSideBar() {
                this.$store.dispatch('ToggleSideBar')
            },
            logout() {
                this.$store.dispatch('LogOut').then(() => {
                    if (this.$socket!==undefined && this.$socket!==null){
                        this.$socket.close();
                    }
                    location.reload() // 为了重新实例化vue-router对象 避免bug
                })
            },
            goChangePw() {
                this.$router.push({path: '/changePassword'});
            },
        },
        data() {
            return {
                icon: admin_icon
            }
        }
    }
</script>


<style type="text/scss" lang="scss" scoped>
    .navbar {
        height: 50px;
        overflow: hidden;
        position: relative;
        background: #fff;
        box-shadow: 0 1px 4px rgba(0, 21, 41, .08);

        .hamburger-container {
            line-height: 46px;
            height: 100%;
            float: left;
            cursor: pointer;
            transition: background .3s;
            -webkit-tap-highlight-color: transparent;

            &:hover {
                background: rgba(0, 0, 0, .025)
            }
        }

        .breadcrumb-container {
            float: left;
        }

        .errLog-container {
            display: inline-block;
            vertical-align: top;
        }

        .right-menu {
            float: right;
            height: 100%;
            line-height: 50px;

            &:focus {
                outline: none;
            }

            .right-menu-item {
                display: inline-block;
                padding: 0 8px;
                height: 100%;
                font-size: 18px;
                color: #5a5e66;
                vertical-align: text-bottom;

                &.hover-effect {
                    cursor: pointer;
                    transition: background .3s;

                    &:hover {
                        background: rgba(0, 0, 0, .025)
                    }
                }
            }

            .avatar-container {
                margin-right: 30px;

                .avatar-wrapper {
                    margin-top: 5px;
                    position: relative;

                    .user-avatar {
                        cursor: pointer;
                        width: 40px;
                        height: 40px;
                        border-radius: 10px;
                    }

                    .el-icon-caret-bottom {
                        cursor: pointer;
                        position: absolute;
                        right: -20px;
                        top: 25px;
                        font-size: 12px;
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue